import CryptoJS from "crypto-js";

const AES_KEY = process.env.REACT_APP_AES_KEY; // Your AES Key

const isProbablyEncrypted = (value) => {
	return typeof value === 'string' && value.startsWith('U2FsdGVk'); // Common prefix in OpenSSL AES encrypted strings
};

const findEncryptedString = (obj) => {
	if (typeof obj !== 'object' || obj === null) return null;

	for (const key in obj) {
		const value = obj[key];

		if (isProbablyEncrypted(value)) {
			return value;
		} else if (typeof value === 'object') {
			const found = findEncryptedString(value);
			if (found) return found;
		}
	}
	return null;
};

const decryptResponseData = (response) => {
	if (!response || !response.data) {
		throw new Error("Invalid response");
	}

	const aesKey = AES_KEY;
	const encryptedData = findEncryptedString(response.data);

	if (!encryptedData) {
		throw new Error("Encrypted data not found");
	}

	try {
		const bytes = CryptoJS.AES.decrypt(encryptedData, aesKey);
		const decrypted = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(decrypted);
	} catch (err) {
		throw new Error("Failed to decrypt or parse data: " + err.message);
	}
};

export { decryptResponseData };